import React, { useEffect } from "react";

export const AdfoxHeaderBidding = ({ hbConfig, templateVersion }) => {
  useEffect(() => {
    const settings = hbConfig[templateVersion];

    if (settings) {
      const script = document.createElement("script");
      script.innerHTML = `
        window.YaHeaderBiddingSettings = {
          biddersMap: ${JSON.stringify(settings.biddersMap)},
          adUnits: ${JSON.stringify(settings.adUnits)},
          timeout: ${settings.timeout},
          trustedOwners: ${JSON.stringify(settings.trustedOwners)},
          ${settings.biddersCpmAdjustmentMap ? `biddersCpmAdjustmentMap: ${JSON.stringify(settings.biddersCpmAdjustmentMap)},` : ''}
        };
      `;
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, [templateVersion]);

  return null;
};
